import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTrigger,
  Disclosure,
  DisclosurePanel,
  Heading,
  Modal,
  ModalOverlay,
} from 'react-aria-components';
import { useNavigate } from 'react-router-dom';

const LineStaffHeader: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div className="p flex w-full flex-col p-1">
        <div className="flex flex-col items-end justify-end">
          <button onClick={() => setIsOpen(!isOpen)}>
            <svg
              width="44"
              height="45"
            >
              <g>
                <path
                  d="M39 7.5H5V9.5H39V7.5ZM39 15.5H5V17.5H39V15.5ZM5 23.5H39V25.5H5V23.5Z"
                  fill="#1A1A1A"
                />
                <path
                  d="M30.9661 33.694C31.321 33.7236 32.0406 33.7531 32.5533 33.7531H37.847C38.3103 33.7531 38.7441 33.7137 39.0004 33.694V35.2417C38.7638 35.2318 38.261 35.1924 37.847 35.1924H32.5533C31.9914 35.1924 31.3309 35.2121 30.9661 35.2417V33.694Z"
                  fill="#1A1A1A"
                />
                <path
                  d="M29.0631 33.556C29.0138 33.6842 28.9842 33.8715 28.9645 33.97C28.8856 34.5517 28.6293 36.2472 28.4815 37.1837H29.1124C29.3687 37.1837 29.8221 37.1739 30.0785 37.1443V38.416C29.8813 38.4061 29.3983 38.3864 29.1321 38.3864H23.9468C23.5919 38.3864 23.3455 38.3963 22.9709 38.416V37.1345C23.237 37.164 23.6018 37.1837 23.9468 37.1837H27.1408C27.2788 36.3458 27.4957 34.946 27.5252 34.3939H24.8636C24.5481 34.3939 24.1637 34.4235 23.8778 34.4432V33.142C24.1341 33.1716 24.5876 33.2011 24.8537 33.2011H27.3774C27.5844 33.2011 27.9886 33.1617 28.1069 33.0927L29.0631 33.556Z"
                  fill="#1A1A1A"
                />
                <path
                  d="M14.4821 31.5646C14.837 31.604 15.3004 31.6237 15.6355 31.6237H19.7167C20.1111 31.6237 20.5349 31.5942 20.811 31.5646V32.994C20.5251 32.9841 20.0618 32.9546 19.7167 32.9546H15.6454C15.2708 32.9546 14.8173 32.9743 14.4821 32.994V31.5646ZM13.6541 36.3851C14.0385 36.4147 14.5019 36.4443 14.8863 36.4443H20.5448C20.88 36.4443 21.294 36.4246 21.6292 36.3851V37.8934C21.2842 37.854 20.8405 37.8343 20.5448 37.8343H14.8863C14.5019 37.8343 14.0188 37.8638 13.6541 37.8934V36.3851Z"
                  fill="#1A1A1A"
                />
                <path
                  d="M12.3442 31.0126C12.216 31.2393 12.0287 31.6731 11.9302 31.8998C11.6344 32.6786 11.1908 33.6743 10.6092 34.5812C11.4767 35.291 12.3048 36.05 12.9751 36.7598L11.9597 37.8836C11.2697 37.0753 10.5599 36.3852 9.77126 35.705C8.90376 36.75 7.77009 37.8442 6.10409 38.7511L5 37.7555C6.60685 36.9767 7.77009 36.0205 8.74603 34.8474C8.03626 34.2855 7.08989 33.5855 6.08438 32.9744L6.92231 31.9688C7.71094 32.4519 8.74603 33.1617 9.54453 33.7531C10.0473 32.9645 10.3825 32.1857 10.6388 31.4069C10.7275 31.1506 10.8359 30.7563 10.8754 30.5L12.3442 31.0126Z"
                  fill="#1A1A1A"
                />
              </g>
            </svg>
          </button>
        </div>
      </div>

      <DialogTrigger
        isOpen={isOpen}
        onOpenChange={() => setIsOpen(false)}
      >
        <ModalOverlay>
          <Modal
            isDismissable
            className="fixed inset-0 z-50 h-full w-full bg-white"
          >
            <Dialog
              key="create-user-dialog"
              role="dialog"
              aria-label="アカウント登録"
              className="mt-24 overflow-y-auto"
            >
              <nav className="flex flex-col p-4">
                <Button
                  className="w-full p-2 py-4 text-start text-base font-bold"
                  onPress={() => {
                    setIsOpen(false);
                    navigate('/staff/offices?redirect=attendance-records');
                  }}
                >
                  本日の利用者
                </Button>

                <Disclosure className="h-full">
                  <Heading>
                    <Button
                      className="flex w-full flex-row items-center justify-between p-2 py-4"
                      slot="trigger"
                    >
                      <div className="text-base font-bold">今月の利用者</div>
                      <svg
                        width="16"
                        height="17"
                      >
                        <g>
                          <path
                            d="M8.0208 11.9886L2.03662 5.92192L2.70153 5.25525L8.0208 10.5886L13.3401 5.25525L14.005 5.92192L8.0208 11.9886Z"
                            fill="#1A1A1A"
                          />
                        </g>
                      </svg>
                    </Button>
                  </Heading>
                  <DisclosurePanel>
                    <Button
                      className="ml-6 text-base font-bold"
                      onPress={() => {
                        setIsOpen(false);
                        navigate('/staff/offices?redirect=support-records');
                      }}
                    >
                      支援記録(実績記録)
                    </Button>
                  </DisclosurePanel>
                </Disclosure>

                <Button
                  className="w-full p-2 py-4 text-start text-base font-bold"
                  onPress={() => {
                    setIsOpen(false);
                    navigate('/staff/offices?redirect=transport');
                  }}
                >
                  送迎予約一覧
                </Button>
              </nav>
            </Dialog>
          </Modal>
        </ModalOverlay>
      </DialogTrigger>
    </>
  );
};

export default LineStaffHeader;
